import React from 'react';
import { FadeIn, Section } from './ui';
import { X } from 'lucide-react';
export function PainSection() {
  const pains = ['Llegas al domingo por la noche y todavía no sabes qué vas a dar el lunes', 'Preparas un examen y a los 5 minutos ya tienes 8 manos levantadas preguntando lo mismo que acabas de explicar', 'Usas siempre los mismos ejercicios porque no tienes tiempo de buscar situaciones reales que les interesen', 'Te quedas hasta las 11 de la noche preparando materiales que otros consiguen en 15 minutos', 'Tienes alumnos con diagnóstico (TEA, TDAH, discalculia) y nadie te enseñó cómo adaptarles el examen legalmente'];
  return <Section variant="light" data-id="element-194">
      <FadeIn data-id="element-195">
        <h2 className="text-[28px] md:text-4xl font-black text-brand-green mb-10 leading-tight" data-id="element-196">
          Si enseñas matemática, esto te va a sonar conocido:
        </h2>
      </FadeIn>

      <div className="space-y-3 mb-10" data-id="element-197">
        {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-198">
            <div className="flex items-start gap-3 bg-white p-4 rounded-xl border border-gray-200 shadow-sm" data-id="element-199">
              <X className="text-red-500 shrink-0 mt-0.5" size={20} data-id="element-200" />
              <p className="text-gray-600 text-[15px] md:text-lg leading-relaxed" data-id="element-201">
                {pain}
              </p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} data-id="element-202">
        <div className="bg-white p-6 md:p-8 rounded-2xl border-l-4 border-brand-green shadow-lg" data-id="element-203">
          <p className="text-gray-900 text-lg md:text-xl leading-relaxed font-medium" data-id="element-204">
            No es que seas mal docente. Es que nadie te enseñó el sistema. En el
            profesorado te enseñaron teoría. Nadie te dio las plantillas y los
            protocolos para ejecutar una clase perfecta sin gastar 3 horas
            preparándola.
          </p>
        </div>
      </FadeIn>
    </Section>;
}